import React from 'react';

// styles
import './main-styles.css';

import PropTypes from 'prop-types';

const ButtonSimple = ({ onPress, label, icon, customClass, isDisabled }) => {
    return (
        <div className="button-wrapper rtl">
            <button disabled={isDisabled} className={customClass} onClick={onPress}>{label}{icon ? icon : null}</button>
        </div>
    )
};

ButtonSimple.propTypes = {
    onPress: PropTypes.func,
    label: PropTypes.string,
    icon: PropTypes.any,
    customClass: PropTypes.string,
    isDisabled: PropTypes.bool
};

export default ButtonSimple;



// WEBPACK FOOTER //
// ./src/Components/Elements/Buttons/ButtonSimple.js